import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import InboxCard from './components/InboxCard';

const Mail = () => {
  const { t } = useTranslation('common');

  return (
    <Container>
      <Row>
        <InboxCard />
      </Row>
    </Container>
  );
};

export default Mail;
